import styled from 'styled-components';

export const DescriptionField = styled.p`
  font-size: 16px;
  letter-spacing: 0.15px;
  color: ${({ theme }) => theme.palette.text.primary};
  word-break: break-word;
  white-space: pre-line;
  margin: 0;
  padding: 0;
  p {
    margin: 0;
    padding: 0;
  }
`;

export const LocationText = styled.p`
  font-weight: 500;
  font-size: 14px;
  letter-spacing: 0.15px;
  color: ${({ theme }) => theme.palette.primary.main};
`;
